var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdTravelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 33.5246C0.976318 82.3043 72.1404 83.2096 69.0352 36.3059C72.5933 -9.36842 7.05762 -12.4085 0.00585938 33.5246ZM52.71 40.9827H52.7163C48.3651 41.949 45.7227 41.3839 42.2563 41.5354C39.2155 40.7918 41.7746 46.2068 32.8481 53.5862C26.7594 57.4989 30.5437 47.5383 33.0957 42.1145C34.1175 41.3591 26.2413 41.894 23.3213 41.8596C16.4708 41.5747 18.405 44.524 16.6489 33.4817C15.4094 24.1894 15.3149 18.4573 17.8804 21.6477C25.7697 33.0641 15.8179 30.2634 37.9146 29.8948C39.5805 30.8531 40.8571 22.0011 43.4834 22.47C44.9003 23.6619 44.1896 29.5176 44.4141 29.51C44.6254 29.8627 45.758 29.528 49.6196 29.4592C58.2061 29.3952 60.7428 38.2694 52.71 40.9827Z",
    fill: "#193666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTravelIcon);
export default __webpack_public_path__ + "static/media/prod-travel-icon.e4ced31cdb700c65a76c22f57dbe54b9.svg";
export { ForwardRef as ReactComponent };